import React from "react";

const Checkbox = ({ name, label, error, ...rest }) => {
  return (
    <div>
      <input {...rest} name={name} id={name} className="form-check-input" />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Checkbox;
